import React, { useState } from "react";
import styles from "./rota_wheel.module.css";
import { Box, Modal, Typography } from "@mui/material";
import Image from "next/image";
import CloseIcon from '@mui/icons-material/Close';
import Head from "next/head";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";


export default function Index() {
  //  ======== wheel modal =======
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //  ======== block1 modal =======
  const [open1, setOpen1] = useState(false);

  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);


  return (
    <>


      <Head>
        <title>Rota The Wheel | School of Our Divine Infinite Being</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        <meta name="keywords" content="ROTA, Tarot, Astrological Tarot, Major Arcana, Minor Arcana, Zodiac Tarot, Alchemy of Tarot, School of Our Divine Infinite Being"></meta>
        <meta name="description" content="Explore the ROTA The Wheel at the School of Our Divine Infinite Being. Delve into the alchemical archetypal formula of Tarot, integrating astrological insights with tarot wisdom."></meta>

        <meta property="og:title" content="ROTA The Wheel | School of Our Divine Infinite Being"></meta>
        <meta property="og:type" content="website" ></meta>
        <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Rota_The_Wheel+_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="og:description" content="Explore the ROTA The Wheel at the School of Our Divine Infinite Being. Delve into the alchemical archetypal formula of Tarot, integrating astrological insights with tarot wisdom."></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta property="og:url" content="https://www.divineinfinitebeing.com/rota-the-wheel"></meta>

        <meta name="author" content="School of Our Divine Infinite Being"></meta>
        <meta name="subject" content="Tarot Education and Astrological Insights"></meta>

        <meta name="language" content="English"></meta>
        <meta name="geo.region" content="US"></meta>
        <meta name="geo.placename" content="Location of Your Institution"></meta>

        <meta property="og:type" content="website"></meta>
        <meta property="og:url" content="https://www.divineinfinitebeing.com/rota-the-wheel"></meta>
        <meta property="og:title" content="ROTA The Wheel | School of Our Divine Infinite Being"></meta>
        <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Rota_The_Wheel+_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="og:image:alt" content="Rota The Wheel"></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/rota-the-wheel"></meta>
        <meta name="twitter:title" content="ROTA The Wheel | Explore Astrological Tarot"></meta>
        <meta name="twitter:description" content="Explore the ROTA The Wheel at the School of Our Divine Infinite Being. Delve into the alchemical archetypal formula of Tarot, integrating astrological insights with tarot wisdom."></meta>
        <meta name="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Rota_The_Wheel+_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/rota-the-wheel" />

      </Head>

      {/* <!------rotathewheelblockone-------> */}
      <div className={styles.rotathewheelblockone}>
        {/* <!------Main Banner section-------> */}
        <div className={styles.asmainwrapper}>
          <div className={styles.rotathewheelblockoneleft}>
            <span className={styles.bannerLogo}>
              <span className={styles.logoviewlink} onClick={handleOpen}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                <img src={`${process.env.cloud_url2}assets/images/viewicon.png`} alt="View_Icon" />
              </span>
              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" /> */}
              <img src={`${process.env.cloud_url2}assets/images/logobanner.webp`} alt="Banner_Logo" />
            </span>
            <h1 data-text="SCHOOL OF OUR DIVINE" >SCHOOL OF OUR DIVINE  </h1>
            <h1 data-text="infinite being">INFINITE BEING</h1>

            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
            <div
              className={`${styles.rotathewheelbottombannerbg} ${styles.bannerboxtxt}`}
            ></div>
          </div>
        </div>
      </div>

      <MysteryBannerNew/>
      {/* ==================== block 1 ======================== */}

      <div className={styles.rotathewheelblockthree}>
        <div
          className={`${styles.countDiv}  ${styles.titleblock}  ${styles.withsubtitle} `}
        >
          <span className={styles.column}>
            <div className={`${styles.col12}  ${styles.h_100}`}>
              <h1>ROTA the Wheel </h1>
              <p>The Alchemical Archetypal formula of the Tarot</p>
            </div>
          </span>
        </div>
        <div className={styles.asmainwrapper}>
          <div className={styles.rotathewheelblockthreeleft}>
            <span className={styles.bannerLogo}>
              <span className={styles.logoviewlink} onClick={handleOpen1}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                <img src={`${process.env.cloud_url2}assets/images/viewicon.png`} alt="View_icon" />
              </span>
              {/* <img
                  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/rota-the-wheel/rotathewheelblockthreeimg.webp"
                  alt="rotathewheelblockthreeimg"/> */}
              <img src={`${process.env.cloud_url2}assets/images/rota-the-wheel/rotathewheelblockthreeimg.webp`} alt="rotathewheel_round_img" />
            </span>
          </div>
        </div>
      </div>

      {/* ==================== block 2 ======================== */}

      <div className={styles.blobk2_main}>
        <div className={styles.common_width_sub}>
          <div className={styles.block2_sub_header_wrpr}>
            <div className={styles.b2_header}>
              <h1>Things to remember</h1>
            </div>
          </div>
        </div>

        {/* ============= min-block1 ================= */}

        <div className={styles.min_block1}>
          <div className={styles.common_width_sub}>
            <div className={styles.orange_min_block_header}>
              <h2>Cards</h2>
            </div>
            {/* *********** card-block *********** */}
            <div className={styles.card_blocks_wrpr}>
              <div className={styles.card_block}>
                <h1>Major Arcana Cards</h1>
                <h2>22</h2>
              </div>
              <div className={styles.card_block}>
                <h1>Court Cards</h1>
                <h2>16</h2>
              </div>
              <div className={styles.card_block}>
                <h1>Minor Arcana Cards</h1>
                <h2>40</h2>
              </div>
              <div className={styles.card_block}>
                <h1>Total Cards</h1>
                <h2>78</h2>
              </div>
            </div>
          </div>
          {/* *********** card-block end *********** */}
          {/* *********** min_block1_body *********** */}
          <div className={styles.min_block1_main_body}>
            <div className={styles.common_width_sub}>
              <div className={styles.min_block1_sub_body}>
                <div className={styles.min_block1_body_left}>
                  <div className={styles.skyblue_header}>
                    <h1>There are four Suit Elements:</h1>
                  </div>
                  <div className={`${styles.logo_textwrpr} ${styles.logo_margin_bottom}`}>
                    <ul>
                      <li><span>Fire</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Fire.png`} />
                      </li>
                      <li><span>Water</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Water.png`} />
                      </li>
                      <li><span>Air</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Air.png`} />
                      </li>
                      <li><span>Earth</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Earth.png`} />
                      </li>
                    </ul>
                  </div>

                  <div className={styles.skyblue_header}>
                    <h1>There are 12 zodiac signs:</h1>
                  </div>
                  <div className={`${styles.logo_textwrpr} ${styles.logo_textwrpr2}`}>
                    <ul>
                      <li><span>Aries</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Aries.png`} />
                      </li>
                      <li><span>Taurus</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Taurus.png`} />

                      </li>
                      <li><span>Gemini</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Gemini.png`} />
                      </li>
                      <li><span>Cancer</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Cancer.png`} />
                      </li>
                      <li><span>Leo</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Leo.png`} />
                      </li>
                      <li><span>Virgo</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Virgo.png`} />
                      </li>
                      <li><span>Libra</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Libra.png`} />
                      </li>
                      <li><span>Scorpio</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio.png`} />
                      </li>
                      <li><span>Sagittarius</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius.png`} />
                      </li>
                      <li><span>Capricorn</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn.png`} />
                      </li>
                      <li><span>Aquarius</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius.png`} />
                      </li>
                      <li><span>Pisces</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Pisces.png`} />
                      </li>
                    </ul>
                  </div>

                  <div className={styles.skyblue_header}>
                    <h1>There are seven Planets and three Mother Elements</h1>
                  </div>
                  <div className={`${styles.logo_textwrpr} ${styles.logo_textwrpr2} ${styles.logo_textwrpr3}`}>
                    <ul>
                      <li><span>Air</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Air.png`} />
                      </li>
                      <li><span>Water</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Water.png`} />
                      </li>
                      <li><span>Mercury</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Mercury.png`} />
                      </li>
                      <li><span>Mars</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Mars.png`} />
                      </li>
                      <li><span>Moon</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Moon.png`} />
                      </li>
                      <li><span>Sun</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Sun.png`} />
                      </li>
                      <li><span>Venus</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Venus.png`} />
                      </li>
                      <li><span>Fire</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Fire.png`} />
                      </li>
                      <li><span>Jupiter</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter.png`} />
                      </li>
                      <li><span>Saturn</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Saturn.png`} />
                      </li>
                    </ul>
                  </div>

                </div>
                <div className={styles.min_block1_body_right}>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/min_block1_body_right_img1.webp" /> */}
                  <img src={`${process.env.cloud_url}rota-the-wheel/min_block1_body_right_img1.webp`} alt="block1_cart_image" />
                </div>
              </div>
            </div>
          </div>
          {/* *********** min_block1_body end *********** */}
        </div>

        {/* ============= min-block1 end ================= */}

        {/* ============= min-block2 ================= */}

        <div className={styles.min_block2}>
          {/* *********** min_block2_body *********** */}
          <div className={styles.min_block1_main_body}>
            <div className={styles.common_width_sub}>
              <div className={styles.min_block1_sub_body}>
                <div className={styles.min_block2_body_left}>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/min_block2_body_left_img1.webp" /> */}
                  <img src={`${process.env.cloud_url}rota-the-wheel/min_block2_body_left_img1.webp`} alt="block2_cart_image" />
                </div>
                <div className={styles.min_block2_body_right}>
                  <div className={styles.orange_min_block_header}>
                    <h2>Major Arcana - Planets and Elements: (7 Planets 3 elements)</h2>
                    <h3>These cards only have planets and elements, they are not ruled by an astrological sign.</h3>
                  </div>
                  <div className={styles.min_block2_body_right_flexwrpr}>
                    <div className={styles.B2_flexwrpr}>
                      <ul>
                        <li><strong>00 - The Fool:</strong> <span>Air</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Air.png`} />
                        </li>
                        <li><strong>I - The Magician:</strong> <span>Mercury</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mercury.png`} />
                        </li>
                        <li><strong>II - The Hign Priestess:</strong> <span>Moon</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Moon.png`} />
                        </li>
                        <li><strong>III - The Empress:</strong> <span>Venus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Venus.png`} />
                        </li>
                        <li><strong>X - The Wheel of Fortune:</strong> <span>Jupiter</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter.png`} />
                        </li>
                      </ul>
                    </div>
                    <div className={styles.B2_flexwrpr}>
                      <ul>
                        <li><strong>XII - The Hanged Man:</strong> <span>Water</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Water.png`} />
                        </li>
                        <li><strong>XVI - The Tower:</strong> <span>Mars</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mars.png`} />
                        </li>
                        <li><strong>XIX - The Sun: </strong> <span>Sun</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sun.png`} />
                        </li>
                        <li><strong>XX - The Aeon:</strong> <span>Fire</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Fire.png`} />
                        </li>
                        <li><strong>XI - The Cosmos:</strong> <span>Saturn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Saturn.png`} />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* *********** min_block2_body end *********** */}
        </div>

        {/* ============= min-block2 end ================= */}
        {/* ============= min-block3 ================= */}
        <div className={styles.min_block3}>
          <div className={styles.common_width_sub}>
            <div className={styles.min_block3_top_section}>
              <div className={styles.orange_min_block_header}>
                <h2>Major Arcana and Zodiac Signs</h2>
              </div>
              <div className={styles.min_block3_table_component}>
                <div className={styles.min_block3_table_sub_component}>
                  <table>
                    <thead>
                      <tr>
                        {/* <th>No.</th> */}
                        <th>Card Name</th>
                        <th>Zodiac Sign</th>
                        <th>Symbol</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* <td data-label="No.">IV</td> */}
                        <td data-label="Card Name">The Emperor</td>
                        <td data-label="Zodiac Sign">Aries</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aries.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">V</td> */}
                        <td data-label="Card Name">The Hierophant</td>
                        <td data-label="Zodiac Sign">Taurus</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Taurus.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">VI</td> */}
                        <td data-label="Card Name">The Lovers</td>
                        <td data-label="Zodiac Sign">Gemini</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Gemini.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">VII</td> */}
                        <td data-label="Card Name">The Chariot</td>
                        <td data-label="Zodiac Sign">Cancer</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Cancer.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">VIII</td> */}
                        <td data-label="Card Name">The Strength</td>
                        <td data-label="Zodiac Sign">Leo</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Leo.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">IX</td> */}
                        <td data-label="Card Name">The Hermit</td>
                        <td data-label="Zodiac Sign">Virgo</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Virgo.png`} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className={styles.table_comp_img}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/min_block3_table_component_img1.webp" /> */}
                    <img src={`${process.env.cloud_url}rota-the-wheel/min_block3_table_component_img1.webp`} alt="block3_table_component" />
                  </div>
                </div>
                <div className={styles.min_block3_table_sub_component}>
                  <table>
                    <thead>
                      <tr>
                        {/* <th>No.</th> */}
                        <th>Card Name</th>
                        <th>Zodiac Sign</th>
                        <th>Symbol</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* <td data-label="No.">XI</td> */}
                        <td data-label="Card Name">The Adjustment</td>
                        <td data-label="Zodiac Sign">Libra</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Libra.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">XIII</td> */}
                        <td data-label="Card Name">The Death</td>
                        <td data-label="Zodiac Sign">Scorpio</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">XIV</td> */}
                        <td data-label="Card Name">The Art</td>
                        <td data-label="Zodiac Sign">Sagittarius</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">XV</td> */}
                        <td data-label="Card Name">The Devil</td>
                        <td data-label="Zodiac Sign">Capricorn</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">XVII</td> */}
                        <td data-label="Card Name">The Star</td>
                        <td data-label="Zodiac Sign">Aquarius</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius.png`} />
                        </td>
                      </tr>
                      <tr>
                        {/* <td data-label="No.">XVIII</td> */}
                        <td data-label="Card Name">The Moon</td>
                        <td data-label="Zodiac Sign">Pisces</td>
                        <td data-label="Symbol">
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Pisces.png`} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className={styles.table_comp_img}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/min_block3_table_component_img2.webp" /> */}
                    <img src={`${process.env.cloud_url}rota-the-wheel/min_block3_table_component_img2.webp`} alt="block3_table_component_image2" />

                  </div>
                </div>
              </div>
            </div>
            <div className={styles.min_block3_bottom_section}>
              <div className={styles.skyblue_header}>
                <h1>There are Four Suits:</h1>
              </div>
              <div className={styles.MB3_four_components}>
                <div className={styles.MB3_four_box}>
                  <h1>Wands / Fire</h1>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/MB3_four_box_img1.webp" /> */}
                  <img src={`${process.env.cloud_url}rota-the-wheel/MB3_four_box_img1.webp`} alt="MB3_four_box_img" />
                </div>
                <div className={styles.MB3_four_box}>
                  <h1>Cups / Water </h1>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/MB3_four_box_img2.webp" /> */}
                  <img src={`${process.env.cloud_url}rota-the-wheel/MB3_four_box_img2.webp`} alt="MB3_four_box_img2" />
                </div>
                <div className={styles.MB3_four_box}>
                  <h1>Swords / Air</h1>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/MB3_four_box_img3.webp" /> */}
                  <img src={`${process.env.cloud_url}rota-the-wheel/MB3_four_box_img3.webp`} alt="MB3_four_box_img3" />
                </div>
                <div className={styles.MB3_four_box}>
                  <h1>Disks / Earth</h1>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/MB3_four_box_img4.webp" /> */}
                  <img src={`${process.env.cloud_url}rota-the-wheel/MB3_four_box_img4.webp`} alt="MB3_four_box_img4" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ============= min-block3 end ================= */}

        {/* ============= min-block4 ================= */}

        <div className={styles.min_block4}>
          <div className={styles.common_width_sub}>
            <div className={styles.min_block4_flexWrpr}>
              <div className={styles.min_block4_flexWrpr_left}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/min_block4_img1.webp" />   */}
                <img src={`${process.env.cloud_url}rota-the-wheel/min_block4_img1.webp`} alt="min_block4_img1" />
              </div>
              <div className={styles.min_block4_flexWrpr_right}>
                <div className={styles.orange_min_block_header}>
                  <h2>Court Cards - Personal, Transitional</h2>
                </div>
                <div className={styles.min_block3_table_sub_component}>
                  <table>
                    <thead>
                      <tr>
                        <th>Suits</th>
                        <th>Knights</th>
                        <th>Queens</th>
                        <th>Princes</th>
                        <th>Princesses</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-label="Suits">
                          <span className={styles.flex_table}>
                            <span>
                              <h1>Wands</h1>
                              <h1>- Zodiac</h1>
                              <h1> - MBTI</h1>
                            </span>
                            <strong>
                              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Wands.png" /> */}
                              <img src={`${process.env.cloud_url}rota-the-wheel/Wands.png`} />
                            </strong>
                          </span>
                        </td>
                        <td data-label="Knights">
                          <p><span>Fire</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Fire</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Scorpio</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio_s.png`} />
                          </strong></p>
                          <p><span>/ Sagittarius</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius_s.png`} />
                          </strong></p>
                          <br />
                          ENTJ-Commander
                        </td>
                        <td data-label="Queens">
                          <p><span>Water</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />

                          </strong></p>
                          of &nbsp;
                          <p><span>Fire</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Pisces</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Pisces_s.png`} />
                          </strong></p>
                          <p><span>/ Aries</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Aries_s.png`} />
                          </strong></p>
                          <br />
                          INTJ- Architect
                        </td>
                        <td data-label="Princes">
                          <p><span>Air</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Fire</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Cancer</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Cancer_s.png`} />
                          </strong></p>
                          <p><span>/ Leo</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Leo_s.png`} />
                          </strong></p>
                          <br />
                          ENTP- Debater
                        </td>
                        <td data-label="Princesses">
                          <span>Personification of </span><p><span>Fire</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                          </strong></p>
                          <p>(element only)</p>
                          <p>INTP- Logician</p>
                        </td>
                      </tr>
                      <tr>
                        <td data-label="Suits">
                          <span className={styles.flex_table}>
                            <span>
                              <h1>Cups</h1>
                              <h1>- Zodiac</h1>
                              <h1> - MBTI</h1>
                            </span>
                            <strong>
                              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cups.png" /> */}
                              <img src={`${process.env.cloud_url}rota-the-wheel/Cups.png`} />
                            </strong>
                          </span>
                        </td>
                        <td data-label="Knights">
                          <p><span>Fire</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Water</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Aquarius</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius_s.png`} />
                          </strong></p>
                          <p><span>/ Pisces</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Pisces_s.png`} />
                          </strong></p>
                          <br />
                          ENFJ- Protagonist
                        </td>
                        <td data-label="Queens">
                          <p><span>Water</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Water</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Gemini</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Gemini_s.png`} />
                          </strong></p>
                          <p><span>/ Cancer</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Cancer_s.png`} />
                          </strong></p>
                          <br />
                          INFJ- Advocate
                        </td>
                        <td data-label="Princes">
                          <p><span>Air</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Water</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Libra</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Libra_s.png`} />
                          </strong></p>
                          <p><span>/ Scorpio</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio_s.png`} />
                          </strong></p>
                          <br />
                          ENFP- Campaigner
                        </td>
                        <td data-label="Princesses">
                          <span>Personification of </span><p><span>Water</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                          </strong></p>
                          <p>(element only)</p>
                          <p>INFP- Mediator</p>
                        </td>
                      </tr>
                      <tr>
                        <td data-label="Suits">
                          <span className={styles.flex_table}>
                            <span>
                              <h1>Swords</h1>
                              <h1> - Zodiac</h1>
                              <h1> - MBTI</h1>
                            </span>
                            <strong>
                              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Swords.png" /> */}
                              <img src={`${process.env.cloud_url}rota-the-wheel/Swords.png`} />
                            </strong>
                          </span>
                        </td>
                        <td data-label="Knights">
                          <p><span>Fire</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Air</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Taurus</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Taurus_s.png`} />
                          </strong></p>
                          <p><span>/ Gemini</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Gemini_s.png`} />
                          </strong></p>
                          <br />
                          ESTJ- Executive
                        </td>
                        <td data-label="Queens">
                          <p><span>Water</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Air</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Virgo</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Virgo_s.png`} />
                          </strong></p>
                          <p><span>/ Libra</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Libra_s.png`} />
                          </strong></p>
                          <br />
                          ISTJ- Logistician
                        </td>
                        <td data-label="Princes">
                          <p><span>Air</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Air</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Capricorn</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn_s.png`} />
                          </strong></p>
                          <p><span>/ Aquarius</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius_s.png`} />
                          </strong></p>
                          <br />
                          ESTP- Entrepreneur
                        </td>
                        <td data-label="Princesses">
                          <span>Personification of </span><p><span>Air</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                          </strong></p>
                          <p>(element only)</p>
                          <p>ISTP- Virtuoso</p>
                        </td>
                      </tr>
                      <tr>
                        <td data-label="Suits">
                          <span className={styles.flex_table}>
                            <span>
                              <h1>Disks</h1>
                              <h1> - Zodiac</h1>
                              <h1> - MBTI</h1>
                            </span>
                            <strong>
                              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Disks.png" /> */}
                              <img src={`${process.env.cloud_url}rota-the-wheel/Disks.png`} />
                            </strong>
                          </span>
                        </td>
                        <td data-label="Knights">
                          <p><span>Fire</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Earth</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Earth_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Leo</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Leo_s.png`} />
                          </strong></p>
                          <p><span>/ Virgo</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Virgo_s.png`} />
                          </strong></p>
                          <br />
                          ESFJ- Consul
                        </td>
                        <td data-label="Queens">
                          <p><span>Water</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Earth</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Earth_s.png`} />
                          </strong></p>
                          <br />
                          <p><span>Sagittarius</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius_s.png`} />
                          </strong></p>
                          <p><span>/ Capricorn</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn_s.png`} />
                          </strong></p>
                          <br />
                          ISFJ- Defender
                        </td>
                        <td data-label="Princes">
                          <p><span>Air</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                          </strong></p>
                          of &nbsp;
                          <p><span>Earth</span>
                            <strong>
                              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth_s.png" /> */}
                              <img src={`${process.env.cloud_url}rota-the-wheel/Earth_s.png`} />
                            </strong></p>
                          <br />
                          <p><span>Aries</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Aries_s.png`} />
                          </strong></p>
                          <p><span>/ Taurus</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Taurus_s.png`} />
                          </strong></p>
                          <br />
                          ESFP- Entertainer
                        </td>
                        <td data-label="Princesses">
                          <span>Personification of </span><p><span>Earth</span><strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Earth_s.png`} />
                          </strong></p>
                          <p>(element only)</p>
                          <p>ISFP- Adventurer</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
            <div className={styles.min_block4_MBTI}>
              <h1>MBTI Full Forms:  E = Extraverted  F = Feeling  I = Introverted  J = Judging  N = INtuition  P = Prospecting  S = Sensation  T = Thinking</h1>
            </div>
          </div>
        </div>

        {/* ============= min-block4 end ================= */}


      </div>

      {/* ==================== block 2 end ======================== */}

      {/* ==================== block 3 ======================== */}
      <div className={styles.block3_main}>
        <div className={styles.common_width_sub}>
          {/* =============== b3 min_block1 =================== */}
          <div className={styles.b3_min_block1}>
            <div className={styles.orange_min_block_header}>
              <h2>Minor Arcana: </h2>
              <h3>Aces: Aces are the elemental roots</h3>
            </div>
            <div className={styles.b3_min_block1_sub_wrpr}>
              <div className={styles.min_block3_table_sub_component}>
                <table>
                  <thead>
                    <tr>
                      <th>Suits</th>
                      <th>Aces</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span className={styles.flex_table}>
                          <span><h1>Wands</h1></span>
                          <strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Wands_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Wands_s.png`} />
                          </strong>
                        </span>
                      </td>
                      <td>Elemental root of <p> Fire <strong>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                      </strong></p></td>
                    </tr>
                  </tbody>
                </table>

                <table>
                  <thead>
                    <tr>
                      <th>Suits</th>
                      <th>Aces</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        <span className={styles.flex_table}>
                          <span><h1>Cups</h1></span>
                          <strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cups_s.png"  /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Cups_s.png`} />
                          </strong>
                        </span>
                      </td>
                      <td>Elemental root of <p> Water <strong>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                      </strong></p></td>
                    </tr>
                  </tbody>
                </table>

                <table>
                  <thead>
                    <tr>
                      <th>Suits</th>
                      <th>Aces</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span className={styles.flex_table}>
                          <span><h1>Swords</h1></span>
                          <strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Swords_s.png"  /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Swords_s.png`} />
                          </strong>
                        </span>
                      </td>
                      <td>Elemental root of <p> Air <strong>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                      </strong></p></td>
                    </tr>
                  </tbody>
                </table>

                <table>
                  <thead>
                    <tr>
                      <th>Suits</th>
                      <th>Aces</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span className={styles.flex_table}>
                          <span><h1>Disks</h1></span>
                          <strong>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Disks_s.png"  /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Disks_s.png`} />
                          </strong>
                        </span>
                      </td>
                      <td>Elemental root of <p> Earth<strong>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Earth_s.png`} />
                      </strong></p>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
          <div className={styles.b3_min_block2}>
            <div className={styles.b3_min_block2_left}>
              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block2_left_img1.webp" /> */}
              <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block2_left_img1.webp`} alt="b3_min_block2_left" />
            </div>
            <div className={styles.b3_min_block2_right}>
              <div className={`${styles.b2_header} `}>
                <h1>Zodiac Cards:</h1>
              </div>
              <div className={`${styles.orange_min_block_header}`}>
                <h3>The list of cards below are associated with one or two zodiac signs. It’s easier to memorize the cards when they are put in the order of the astrological calendar.</h3>
              </div>
              <div className={styles.b3_min_block2_right_box_flex_wrpr}>
                <div className={styles.b3_min_block2_right_box}>
                  <div className={styles.b3_min_block2_right_box_top}>
                    <div className={styles.b3_min_block2_right_box_LT}>
                      <h1><span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries_xl.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Aries_xl.png`} />
                      </span><strong>ARIES TAROT CARDS</strong></h1>
                      <h2>Aries will be associated with the following minor arcana cards.</h2>
                    </div>
                    <div className={styles.b3_min_block2_right_box_RT}>
                      {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block2_right_box_RT_img1.webp" /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block2_right_box_RT_img1.webp`} />
                    </div>
                  </div>
                  <div className={styles.b3_min_block2_right_box_bottom}>
                    <h1>Minor Arcana:</h1>
                    <ul>
                      <li><strong>Two of Wands: Dominion - </strong>1st decan of <p><span> Aries</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Aries_s.png`} />
                      </p><p ><span>-Mars</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                        </p></li>
                      <li><strong>Three of Wands: Virtue - </strong>2nd decan of <p><span> Aries</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Aries_s.png`} />
                      </p><p ><span>-Sun</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" />s */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sun_s.png`} />
                        </p></li>
                      <li><strong>Four of Wands: Completion - </strong>3rd decan of <p><span> Aries</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Aries_s.png`} />
                      </p><p><span>-Venus</span>
                          {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                        </p></li>
                    </ul>
                  </div>
                </div>
                <div className={styles.b3_min_block2_right_box}>
                  <div className={styles.b3_min_block2_right_box_top}>
                    <div className={styles.b3_min_block2_right_box_LT}>
                      <h1><span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus_xl.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Taurus_xl.png`} />
                      </span><strong>TAURUS TAROT CARDS</strong></h1>
                      <h2>Taurus will be associated with the following minor arcana cards.</h2>
                    </div>
                    <div className={styles.b3_min_block2_right_box_RT}>
                      {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block2_right_box_RT_img2.webp" /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block2_right_box_RT_img2.webp`} />
                    </div>
                  </div>
                  <div className={styles.b3_min_block2_right_box_bottom}>
                    <h1>Minor Arcana:</h1>
                    <ul>
                      <li><strong>Five of Disks: Worry - </strong>1st decan of <p><span> Taurus</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Taurus_s.png`} />
                      </p><p ><span>-Mercury</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                        </p></li>
                      <li><strong>Six of Disks: Success - </strong>2nd decan of <p><span> Taurus</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Taurus_s.png`} />
                      </p><p ><span>-Moon</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                        </p></li>
                      <li><strong>Seven of Disks: Failure - </strong>3rd decan of <p><span> Taurus</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Taurus_s.png`} />
                      </p><p><span>-Saturn</span>
                          {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                        </p></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.b3_min_block3}>
            <div className={styles.b3_min_block2}>
              <div className={styles.b3_min_block2_left}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block3_left_img1.webp" /> */}
                <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block3_left_img1.webp`} alt="b3_min_block3_left_img1" />
              </div>
              <div className={styles.b3_min_block2_right}>
                <div className={styles.b3_min_block2_right_box_flex_wrpr}>
                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Gemini_xl.png`} />
                        </span><strong>GEMINI TAROT CARDS</strong></h1>
                        <h2>Gemini will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block3_right_box_RT_img1.webp" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block3_right_box_RT_img1.webp`} />
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Eight of Swords: Interference -</strong>1st decan of <p><span> Gemini</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Gemini_s.png`} />

                        </p><p ><span>-Jupiter</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                          </p></li>
                        <li><strong>Nine of Swords: Cruelty - </strong>2nd decan of <p><span> Gemini</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Gemini_s.png`} />
                        </p><p ><span>-Mars</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                          </p></li>
                        <li><strong>Ten of Swords: Ruin - </strong>3rd decan of <p><span> Gemini</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Gemini_s.png`} />
                        </p><p><span>-Mercury</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>
                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Cancer_xl.png`} />

                        </span><strong>CANCER TAROT CARDS</strong></h1>
                        <h2>Cancer will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block3_right_box_RT_img2.webp" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block3_right_box_RT_img2.webp`} />
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Two of Cups: Love - </strong>1st decan of <p><span> Cancer</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Cancer_s.png`} />
                        </p><p ><span>-Venus</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                          </p></li>
                        <li><strong>Three of Cups: Abundance - </strong>2nd decan of <p><span> Cancer</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Cancer_s.png`} />
                        </p><p ><span>-Mercury</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                          </p></li>
                        <li><strong>Four of Cups: Luxury - </strong>3rd decan of <p><span> Cancer</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Cancer_s.png`} />
                        </p>
                          <p><span>-Moon</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.b3_min_block4}>
            <div className={styles.b3_min_block2}>
              <div className={styles.b3_min_block2_left}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block4_left_img1.webp" /> */}
                <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block4_left_img1.webp`} alt="b3_min_block4_left_img1" />
              </div>
              <div className={styles.b3_min_block2_right}>
                <div className={styles.b3_min_block2_right_box_flex_wrpr}>

                  {/* <div className={styles.b3_min_block2_right_box}>
                        <div className={styles.b3_min_block2_right_box_top}>
                          <div className={styles.b3_min_block2_right_box_LT}>
                            <h1><span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_xl.png" /></span><strong>LIBRA TAROT CARDS</strong></h1>
                            <h2>Libra will be associated with the following minor arcana cards.</h2>
                          </div>
                          <div className={styles.b3_min_block2_right_box_RT}>
                            <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block4_right_box_RT_img2.webp" />
                          </div>
                        </div>
                        <div className={styles.b3_min_block2_right_box_bottom}>
                          <h1>Minor Arcana:</h1>
                          <ul>
                            <li><strong>Two of Swords: Peace - </strong>1st decan of <p><span> Libra</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /></p><p ><span>-Moon</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /></p></li>
                            <li><strong>Three of Swords: Sorrow - </strong>2nd decan of <p><span> Libra</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /></p><p ><span>-Saturn</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /></p></li>
                            <li><strong>Four of Swords: Truce - </strong>3rd decan of <p><span> Libra</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /></p><p><span>-Jupiter</span><img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /></p></li>
                          </ul>
                        </div>
                      </div> */}
                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Leo_xl.png`} />
                        </span><strong>LEO TAROT CARDS</strong></h1>
                        <h2>Leo will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block5_right_box_RT_img1.webp" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block5_right_box_RT_img1.webp`} />
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Five of Wands: Strife - </strong>1st decan of <p><span> Leo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Leo_s.png`} />
                        </p><p ><span>-Saturn</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                          </p></li>
                        <li><strong>Six of Wands: Victory - </strong>2nd decan of <p><span> Leo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Leo_s.png`} />
                        </p><p ><span>-Jupiter</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                          </p></li>
                        <li><strong>Seven of Wands: Valour -  </strong>3rd decan of <p><span> Leo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Leo_s.png`} />
                        </p><p><span>-Mars</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>

                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Virgo_xl.png`} />
                        </span><strong>VIRGO TAROT CARDS</strong></h1>
                        <h2>Virgo will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block4_right_box_RT_img1.webp" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block4_right_box_RT_img1.webp`} />
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Eight of Disks: Prudence - </strong>1st decan of <p><span> Virgo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Virgo_s.png`} />
                        </p><p ><span>-Sun</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Sun_s.png`} />
                          </p></li>
                        <li><strong>Nine of Disks: Gain - </strong>2nd decan of <p><span> Virgo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Virgo_s.png`} />
                        </p><p ><span>-Venus</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                          </p></li>
                        <li><strong>Ten of Disks: Wealth - </strong>3rd decan of <p><span> Virgo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Virgo_s.png`} />
                        </p><p><span>-Mercury</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.b3_min_block5}>
            <div className={styles.b3_min_block2}>
              <div className={styles.b3_min_block2_left}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block5_left_img1.webp" /> */}
                <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block5_left_img1.webp`} alt="b3_min_block5_left_img1" />
              </div>
              <div className={styles.b3_min_block2_right}>
                <div className={styles.b3_min_block2_right_box_flex_wrpr}>

                  {/* <div className={styles.b3_min_block2_right_box}>
                        <div className={styles.b3_min_block2_right_box_top}>
                          <div className={styles.b3_min_block2_right_box_LT}>
                            <h1><span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_xl.png" /></span><strong>LEO TAROT CARDS</strong></h1>
                            <h2>Leo will be associated with the following minor arcana cards.</h2>
                          </div>
                          <div className={styles.b3_min_block2_right_box_RT}>
                            <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block5_right_box_RT_img1.webp" />
                          </div>
                        </div>
                        <div className={styles.b3_min_block2_right_box_bottom}>
                          <h1>Minor Arcana:</h1>
                          <ul>
                            <li><strong>Five of Wands: Strife - </strong>1st decan of <p><span> Leo</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /></p><p ><span>-Saturn</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /></p></li>
                            <li><strong>Six of Wands: Victory - </strong>2nd decan of <p><span> Leo</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /></p><p ><span>-Jupiter</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /></p></li>
                            <li><strong>Seven of Wands: Valour -  </strong>3rd decan of <p><span> Leo</span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /></p><p><span>-Mars</span><img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /></p></li>
                          </ul>
                        </div>
                      </div> */}
                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Libra_xl.png`} />
                        </span><strong>LIBRA TAROT CARDS</strong></h1>
                        <h2>Libra will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block4_right_box_RT_img2.webp" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block4_right_box_RT_img2.webp`} />
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Two of Swords: Peace - </strong>1st decan of <p><span> Libra</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Libra_s.png`} />
                        </p><p ><span>-Moon</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                          </p></li>
                        <li><strong>Three of Swords: Sorrow - </strong>2nd decan of <p><span> Libra</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Libra_s.png`} />
                        </p><p ><span>-Saturn</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                          </p></li>
                        <li><strong>Four of Swords: Truce - </strong>3rd decan of <p><span> Libra</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Libra_s.png`} />
                        </p><p><span>-Jupiter</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>

                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio_xl.png`} />
                        </span><strong>SCORPIO TAROT CARDS</strong></h1>
                        <h2>Scorpio will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block5_right_box_RT_img2.webp" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block5_right_box_RT_img2.webp`} />
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Five of Cups: Disappointment - </strong>1st decan of <p><span> Scorpio</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio_s.png`} />
                        </p><p ><span>-Mars</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                          </p></li>
                        <li><strong>Six of Cups: Pleasure - </strong>2nd decan of <p><span> Scorpio</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio_s.png`} />
                        </p><p ><span>-Sun</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Sun_s.png`} />
                          </p></li>
                        <li><strong>Seven of Cups: Debauch - </strong>3rd decan of <p><span> Scorpio</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio_s.png`} />
                        </p><p><span>-Venus</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.b3_min_block6}>
            <div className={styles.b3_min_block2}>
              <div className={styles.b3_min_block2_left}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block6_left_img1.webp" /> */}
                <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block6_left_img1.webp`} alt="b3_min_block6_left_img1" />
              </div>
              <div className={styles.b3_min_block2_right}>
                <div className={styles.b3_min_block2_right_box_flex_wrpr}>
                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius_xl.png`} />
                        </span><strong>SAGITTARIUS TAROT CARDS</strong></h1>
                        <h2>Sagittarius will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block6_right_box_RT_img1.webp" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block6_right_box_RT_img1.webp`} />
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Eight of Wands: Swiftness - </strong>1st decan of <p><span> Sagittarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius_s.png`} />
                        </p><p ><span>-Mercury</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                          </p></li>
                        <li><strong>Nine of Wands: Strength - </strong>2nd decan of <p><span> Sagittarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius_s.png`} />
                        </p><p ><span>-Moon</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                          </p></li>
                        <li><strong>Ten of Wands: Oppression - </strong>3rd decan of <p><span> Sagittarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius_s.png`} />
                        </p><p><span>-Saturn</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>
                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn_xl.png`} />
                        </span><strong>CAPRICORN TAROT CARDS</strong></h1>
                        <h2>Capricorn will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block6_right_box_RT_img2_new.png" />
                        {/* <img src={`${process.env.cloud_url}b3_min_block6_right_box_RT_img2_new.png`} /> */}
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Two of Disks: Change - </strong>1st decan of <p><span> Capricorn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn_s.png`} />
                        </p><p ><span>-Jupiter</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                          </p></li>
                        <li><strong>Three of Disks: Works - </strong>2nd decan of <p><span> Capricorn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn_s.png`} />
                        </p><p ><span>-Mars</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                          </p></li>
                        <li><strong>Four of Disks: Power - </strong>3rd decan of <p><span> Capricorn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn_s.png`} />
                        </p><p><span>-Sun</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Sun_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.b3_min_block7}>
            <div className={styles.b3_min_block2}>
              <div className={styles.b3_min_block2_left}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block7_left_img1.webp" /> */}
                <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block7_left_img1.webp`} alt="b3_min_block7_left_img1" />
              </div>
              <div className={styles.b3_min_block2_right}>
                <div className={styles.b3_min_block2_right_box_flex_wrpr}>
                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius_xl.png`} />

                        </span><strong>AQUARIUS TAROT CARDS</strong></h1>
                        <h2>Aquarius will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block7_right_box_RT_img1.webp" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block7_right_box_RT_img1.webp`} />
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Five of Swords: Defeat - </strong>1st decan of <p><span> Aquarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius_s.png`} />
                        </p><p ><span>-Venus</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                          </p></li>
                        <li><strong>Six of Swords: Science - </strong>2nd decan of <p><span> Aquarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius_s.png`} />
                        </p><p ><span>-Mercury</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                          </p></li>
                        <li><strong>Seven of Swords: Futility - </strong>3rd decan of <p><span> Aquarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius_s.png`} />
                        </p><p><span>-Moon</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>
                  <div className={styles.b3_min_block2_right_box}>
                    <div className={styles.b3_min_block2_right_box_top}>
                      <div className={styles.b3_min_block2_right_box_LT}>
                        <h1><span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces_xl.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Pisces_xl.png`} />
                        </span><strong>PISCES TAROT CARDS</strong></h1>
                        <h2>Pisces will be associated with the following minor arcana cards.</h2>
                      </div>
                      <div className={styles.b3_min_block2_right_box_RT}>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b3_min_block7_right_box_RT_img2.webp" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/b3_min_block7_right_box_RT_img2.webp`} />
                      </div>
                    </div>
                    <div className={styles.b3_min_block2_right_box_bottom}>
                      <h1>Minor Arcana:</h1>
                      <ul>
                        <li><strong>Eight of Cups: Indolence - </strong>1st decan of <p><span> Pisces</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Pisces_s.png`} />
                        </p><p ><span>-Saturn</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                          </p></li>
                        <li><strong>Nine of Cups: Happiness - </strong>2nd decan of <p><span> Pisces</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Pisces_s.png`} />
                        </p><p ><span>-Jupiter</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                          </p></li>
                        <li><strong>Ten of Cups: Satiety  - </strong>3rd decan of <p><span> Pisces</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Pisces_s.png`} />
                        </p><p><span>-Mars</span>
                            {/* <img  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                          </p></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      {/* ==================== block 3 end ======================== */}

      {/* ==================== block 4 ======================== */}
      <div className={styles.block4_main}>
        <div className={styles.common_width_sub}>
          <div className={styles.orange_min_block_header}>
            <h2>The Minor Arcana of the Tarot, the daimōnic forces of generative experience</h2>
          </div>
          <div className={styles.table_b4_main_wrpr}>
            <table>
              <thead>
                <tr>
                  <th>
                    <p>
                      <span>Fire</span>
                      {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png' /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                      <span> - Wands</span>
                      {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Wands_sxl.png" /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/Wands_sxl.png`} />
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Water</span>
                      {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png' /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                      <span> - Cups</span>
                      {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cups_sxl.png" /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/Cups_sxl.png`} />
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Air</span>
                      {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png' /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                      <span> - Swords</span>
                      {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Swords_sxl.png" /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/Swords_sxl.png`} />
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Earth</span>
                      {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth_s.png' /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/Earth_s.png`} />
                      <span> - Discs</span>
                      {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Discs_sxl.png" /> */}
                      <img src={`${process.env.cloud_url}rota-the-wheel/Discs_sxl.png`} />
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='1' className={styles.fd_unset}>
                      <span>Ace -&nbsp;</span>
                      <strong>
                        <span>Source</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                      </strong>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p className={styles.fd_unset}>
                      <span>Ace -&nbsp;</span>
                      <strong>
                        <span>Source</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                      </strong>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p className={styles.fd_unset}>
                      <span>Ace -&nbsp;</span>
                      <strong>
                        <span>Source</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                      </strong>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p className={styles.fd_unset}>
                      <span>Ace -&nbsp;</span>
                      <strong>
                        <span>Source</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth_s.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Earth_s.png`} />
                      </strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='2'>
                      <span className={styles.dsplay_block}>
                        <span>Dominion&nbsp; </span>
                        <strong>
                          <span>Mars</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                        </strong>
                      </span>
                      <span className={styles.dsplay_block}>in&nbsp;
                        <strong>
                          <span> Aries</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aries_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Love</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Venus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span> Cancer</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Cancer_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Peace</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Moon</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Libra</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Libra_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Change</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Jupiter</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          {/* <span>Capricorn</span> <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='3'>
                      <span className={styles.dsplay_block}>
                        <span>Virtue&nbsp;</span>
                        <strong>
                          <span>Sun</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sun_s.png`} />
                        </strong>
                      </span>
                      <span className={styles.dsplay_block}>
                        in&nbsp;
                        <strong>
                          <span>Aries</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aries_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Abundance</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Mercury</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Cancer</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Cancer_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Sorrow</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Saturn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Libra</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Libra_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Works</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Mars</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Capricorn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='4'>
                      <span className={styles.dsplay_block}>
                        <span>Completion&nbsp;</span>
                        <strong>
                          <span>Venus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                        </strong>
                      </span>
                      <span className={styles.dsplay_block}>
                        in&nbsp;
                        <strong>
                          <span>Aries</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aries_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aries_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Luxury</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Moon</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Cancer</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cancer_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Cancer_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Truce</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Jupiter</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Libra</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Libra_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Libra_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Power</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Sun</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sun_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Capricorn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Capricorn_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='5'>
                      <span className={styles.dsplay_block}>
                        <span>Strife&nbsp;</span>
                        <strong>
                          <span>Saturn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                        </strong>
                      </span>
                      <span className={styles.dsplay_block}>
                        in&nbsp;
                        <strong>
                          <span>Leo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Leo_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Disappointment</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Mars</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Scorpio</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Defeat</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Venus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Aquarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Worry</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Mercury</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Taurus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Capricorn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Taurus_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='6'>
                      <span className={styles.dsplay_block}>
                        <span>Victory&nbsp;</span>
                        <strong>
                          <span>Jupiter</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                        </strong>
                      </span>
                      <span className={styles.dsplay_block}>
                        in&nbsp;
                        <strong>
                          <span>Leo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/ccc" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Pleasure</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Sun</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sun_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Scorpio</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Science</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Mercury</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Aquarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Success</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Moon</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Taurus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Taurus_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='7'>
                      <span className={styles.dsplay_block}>
                        <span>Valour&nbsp;</span>
                        <strong>
                          <span>Mars</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                        </strong>
                      </span>
                      <span className={styles.dsplay_block}>
                        in&nbsp;
                        <strong>
                          <span>Leo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Leo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Leo_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Debauch</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Venus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Scorpio</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Scorpio_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Scorpio_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Futility</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Moon</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Aquarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Aquarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Aquarius_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Failure</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Saturn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Taurus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Taurus_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Taurus_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='8'>
                      <span className={styles.dsplay_block}>
                        <span>Swiftness&nbsp;</span>
                        <strong>
                          <span>Venus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                        </strong>
                      </span>
                      <span className={styles.dsplay_block}>
                        in&nbsp;
                        <strong>
                          <span>Sagittarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Indolence</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Saturn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Pisces</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Pisces_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Interference</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Jupiter</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Gemini</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Gemini_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Prudence</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Sun</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sun_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Virgo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Virgo_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='9'>
                      <span className={styles.dsplay_block}>
                        <span>Strength&nbsp;</span>
                        <strong>
                          <span>Moon</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Moon_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Moon_s.png`} />
                        </strong>
                      </span>
                      <span className={styles.dsplay_block}>
                        in&nbsp;
                        <strong>
                          <span>Sagittarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Happiness</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Jupiter</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Jupiter_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Jupiter_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Pisces</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Pisces_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Cruelty</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Mars</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Gemini</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Gemini_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Gain</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Venus</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Venus_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Venus_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Virgo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Virgo_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td data-label="Fire - Wands">
                    <p data-label='10'>
                      <span className={styles.dsplay_block}>
                        <span>Oppression&nbsp;</span>
                        <strong>
                          <span>Saturn</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Saturn_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Saturn_s.png`} />
                        </strong>
                      </span>
                      <span className={styles.dsplay_block}>
                        in&nbsp;
                        <strong>
                          <span>Sagittarius</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sagittarius_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sagittarius_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Water - Cups">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Satiety</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Mars</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mars_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mars_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Pisces</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Pisces_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Pisces_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Air - Swords">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Ruin</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Sun</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Sun_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Sun_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Gemini</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Gemini_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Gemini_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                  <td data-label="Earth - Discs">
                    <p>
                      <span className={styles.dsplay_block}>
                        <span>Wealth</span>
                      </span>
                      <span className={styles.dsplay_block}>
                        <strong>
                          <span>Mercury</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Mercury_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Mercury_s.png`} />
                        </strong>
                        in&nbsp;
                        <strong>
                          <span>Virgo</span>
                          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Virgo_s.png" /> */}
                          <img src={`${process.env.cloud_url}rota-the-wheel/Virgo_s.png`} />
                        </strong>
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={styles.block4_main_min_block2}>
            <div className={styles.orange_min_block_header}>
              <h2>Greek Daemonic counterparts to the Minor Arcana of the Divine Arcana Tarot</h2>
            </div>
            <div className={styles.table_b4_main_minB2_wrpr}>
              <div className={styles.b4_main_minB2_left}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/b4_main_minB2_left_img1.webp"  /> */}
                <img src={`${process.env.cloud_url}rota-the-wheel/b4_main_minB2_left_img1.webp`} alt="b4_main_minB2_left_img1" />
              </div>
              <div className={styles.b4_main_minB2_right}>
                <div className={styles.b4M_min_2_container}>
                  <div className={`${styles.b4M_min_2_container_body} ${styles.border_left_add} ${styles.Padding_alignment}`}>
                    <div className={styles.b4M_min_2_container_header}>
                      <p>
                        <span>Fire</span>
                        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png' />  */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                        <span> - Wands</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Wands_sxl.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Wands_sxl.png`} />
                      </p>
                    </div>
                    <ul>
                      <li>
                        <strong>1</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Ace - Source</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Fire_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Fire_s.png`} />
                          </span>
                        </p>
                      </li>
                      <li>
                        <strong>2</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Kratos - Dominion</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <strong>3</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Arete - Virtue</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <strong>4</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Telesphorus - Completion</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <strong>5</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Eris - Strife</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <strong>6</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Nike - Victory</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <strong>7</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Alke - Valour</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <strong>8</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Hormes - Swiftness</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <strong>9</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Thrasos - Strength</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <strong>10</strong>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Adrasteia - Oppression</span>
                          </span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={styles.b4M_min_2_container}>
                  <div className={styles.b4M_min_2_container_body}>
                    <div className={styles.b4M_min_2_container_header}>
                      <p>
                        <span>Water</span>
                        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png' />  */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                        <span> - Cups</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Cups_sxl.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Cups_sxl.png`} />
                      </p>
                    </div>
                    <ul>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Ace - Source</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Water_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Water_s.png`} />
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Eros - Love</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Euthenia - Abundance</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Philotes - Luxury</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Algea - Disappointment</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Hedone - Pleasure</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Methe - Debauch</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Aergia - Indolence</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Kharites - Happiness</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Koros - Satiety</span>
                          </span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={styles.b4M_min_2_container}>
                  <div className={styles.b4M_min_2_container_body}>
                    <div className={styles.b4M_min_2_container_header}>
                      <p>
                        <span>Air</span>
                        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png' />  */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                        <span> - Swords</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Swords_sxl.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Swords_sxl.png`} />
                      </p>
                    </div>
                    <ul>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Ace - Source</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Air_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Air_s.png`} />
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Eirene - Peace</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Penthos - Sorrow</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Ekekheira - Truce</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Typhoeus - Defeat</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Daedalus - Science</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Sisyphus - Futility</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Amphilogiai - Interference</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Hybris - Cruelty</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Ate - Ruin</span>
                          </span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={styles.b4M_min_2_container}>
                  <div className={`${styles.b4M_min_2_container_body} `}>
                    <div className={styles.b4M_min_2_container_header}>
                      <p>
                        <span>Earth</span>
                        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth_s.png' />  */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Earth_s.png`} />
                        <span> - Discs</span>
                        {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Discs_sxl.png" /> */}
                        <img src={`${process.env.cloud_url}rota-the-wheel/Discs_sxl.png`} />
                      </p>
                    </div>
                    <ul>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Ace - Source</span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/Earth_s.png" /> */}
                            <img src={`${process.env.cloud_url}rota-the-wheel/Earth_s.png`} />
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Kairos - Change</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Ponos - Works</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Bia - Power</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Oizys - Worry</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Bonus Eventus - Success</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Aporia - Failure</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Epiphron - Prudence</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Kairos - Gain</span>
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span className={styles.dsplay_block}>
                            <span>Ploutos - Wealth</span>
                          </span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ==================== block 4 end ======================== */}






























      {/* =============== wheel modal ================ */}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box">
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className="modal_banner"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
            </div>
          </Typography>
        </Box>
      </Modal>

      {/* =============== block1 modal ================ */}

      <Modal
        open={open1}
        onClose={handleClose1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box">
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className="modal_banner"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleClose1}>
                <CloseIcon />
              </span>
              <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/rota-the-wheel/rotathewheelblockthreeimg.webp" />
            </div>
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
